import { IntlFormatters } from 'react-intl';

import { LoyaltyServiceMode } from 'generated/graphql-gateway';
import { OffersServiceMode } from 'state/loyalty/offers/types';
import { ServiceMode } from 'state/service-mode/types';

const pickUpServiceModes = new Set<string>([
  LoyaltyServiceMode.CATERING_PICKUP,
  LoyaltyServiceMode.DRIVE_THRU,
  LoyaltyServiceMode.EAT_IN,
  LoyaltyServiceMode.TABLE_SERVICE,
  LoyaltyServiceMode.TAKEOUT,
]);
function isPickUpServiceMode(serviceMode: string | null) {
  return serviceMode && pickUpServiceModes.has(serviceMode);
}

const deliveryServiceModes = new Set<string>([
  LoyaltyServiceMode.CATERING_DELIVERY,
  LoyaltyServiceMode.DELIVERY,
]);
function isDeliveryServiceMode(serviceMode: string | null) {
  return serviceMode && deliveryServiceModes.has(serviceMode);
}

export function getOfferServiceMode(
  offerServiceModes: ReadonlyArray<LoyaltyServiceMode | null> | undefined | null
) {
  if (!offerServiceModes || !offerServiceModes.length) {
    return;
  }

  const hasPickupService = offerServiceModes.some(isPickUpServiceMode);
  const hasDeliveryService = offerServiceModes.some(isDeliveryServiceMode);

  if (hasDeliveryService && !hasPickupService) {
    return OffersServiceMode.DELIVERY_ONLY;
  } else if (hasPickupService && !hasDeliveryService) {
    return OffersServiceMode.PICKUP_ONLY;
  }

  return;
}

export function getServiceModeUnavailableMessage(
  selectedServiceMode: ServiceMode | null,
  offerServiceMode: OffersServiceMode | undefined,
  formatMessage: IntlFormatters['formatMessage']
) {
  if (!selectedServiceMode) {
    return;
  }

  if (
    isDeliveryServiceMode(selectedServiceMode) &&
    offerServiceMode === OffersServiceMode.PICKUP_ONLY
  ) {
    return formatMessage({ id: 'availableForPickUp' });
  } else if (
    isPickUpServiceMode(selectedServiceMode) &&
    offerServiceMode === OffersServiceMode.DELIVERY_ONLY
  ) {
    return formatMessage({ id: 'availableForDelivery' });
  }

  return;
}

export type ServiceModeUnavailableMessageGenerator = (
  offerServiceMode: OffersServiceMode | undefined
) => string | undefined;

export function buildServiceModeUnavailableMessageGenerator(
  selectedServiceMode: ServiceMode | null,
  formatMessage: IntlFormatters['formatMessage']
): ServiceModeUnavailableMessageGenerator {
  return (offerServiceMode: OffersServiceMode | undefined) =>
    getServiceModeUnavailableMessage(selectedServiceMode, offerServiceMode, formatMessage);
}
